import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import { rem } from 'polished';
import { display, lineHeight, color, fontSize } from 'styled-system';
import { ExternalLink as BaseExternalLink, Text, Box, Flex, Container, ExternalLinkProps } from '@qga/roo-ui/components';
import { oneworld } from '@qga/roo-ui/logos';
import {
  CONTACT_US_URL,
  FAQ_URL,
  PRIVACY_AND_SECURITY_URL,
  TERMS_OF_USE_URL,
  AUSTRALIAN_DESTINATIONS_URL,
  TRAVEL_AGENT_LICENSE_NUMBER,
  ABN,
} from 'config/constants';
import { FC } from 'react';

const Logo = styled.img`
  width: ${rem('40px')};
  margin-right: ${themeGet('space.4')};
  margin-top: -${themeGet('space.2')};
`;

const ExternalLink = styled(BaseExternalLink)`
  ${color};
  ${display};
  ${lineHeight};
  ${fontSize};
`;

const FooterExternalLink: FC<ExternalLinkProps> = (props) => (
  <ExternalLink
    fontSize="sm"
    mr={[0, 4, 0]}
    ml={[0, 0, 4]}
    py={1}
    lineHeight="tight"
    color="greys.steel"
    display={['block', 'inline-block', 'inline-block']}
    {...props}
  />
);

FooterExternalLink.displayName = 'FooterExternalLink';

const GlobalFooter = () => (
  <Box pt={[2, 6, 6]} pb={[6, 9, 9]} borderTop={2} borderColor="brand.primary" color="greys.steel" bg="white">
    <Container pt={6} pb={9}>
      <Flex justifyContent="space-between" flexDirection={['column-reverse', 'column-reverse', 'row']}>
        <Flex alignItems="flex-start" mt={[8, 8, 0]}>
          <Logo src={oneworld} alt="One World Logo" role="img" aria-label="One World Logo" />
          <Text fontSize="sm" lineHeight="tight" p={1}>
            Travel agents license No. {TRAVEL_AGENT_LICENSE_NUMBER}
          </Text>
        </Flex>
        <Flex flexDirection="column" justifyContent="flex-end">
          <Box>
            <FooterExternalLink href={CONTACT_US_URL}>Contact</FooterExternalLink>
            <FooterExternalLink my={[2, 0]} href={PRIVACY_AND_SECURITY_URL}>
              Privacy &amp; Security
            </FooterExternalLink>
            <FooterExternalLink my={[2, 0]} href={TERMS_OF_USE_URL}>
              Terms of use
            </FooterExternalLink>
            <FooterExternalLink my={[2, 0]} href={AUSTRALIAN_DESTINATIONS_URL}>
              Australian destinations
            </FooterExternalLink>
            <FooterExternalLink my={[2, 0]} href={FAQ_URL}>
              FAQs
            </FooterExternalLink>
          </Box>
          <Box textAlign={['left', 'left', 'right']} pr={1}>
            <Text fontSize="sm">&copy; Qantas Airways Limited ABN {ABN}</Text>
          </Box>
        </Flex>
      </Flex>
    </Container>
  </Box>
);

export default GlobalFooter;
